import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // import Link
import AnimatedButton from "../components/AnimatedButton";
import services2 from "../assets/images/services/services-2.png";
import services3 from "../assets/images/services/services-3.png";
import services4 from "../assets/images/services/services-4.png";
import services5 from "../assets/images/services/services-5.png";

function Services() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const services = [
    {
      id: 1,
      title: "Corporate Housekeeping",
      slug: "corporate-housekeeping", // add slug
      description:
        "Professional cleaning tailored for office spaces, ensuring a spotless environment...",
      coreFeatures: [
        "Eco-friendly cleaning products",
        "Regular maintenance schedules",
        "Sanitization of high-touch areas",
        "Waste management and recycling",
        "Customizable service plans",
      ],
      image: services2,
    },
    {
      id: 2,
      title: "Industrial Housekeeping",
      slug: "industrial-housekeeping",
      description:
        "Specialized cleaning services for factories and warehouses designed to uphold safety standards...",
      coreFeatures: [
        "Hazardous waste removal",
        "Dust and debris clearing",
        "Compliance with safety regulations",
        "Heavy-duty equipment cleaning",
        "Scheduled and emergency cleaning",
      ],
      image: services3,
    },
    {
      id: 3,
      title: "Facade Cleaning",
      slug: "facade-cleaning",
      description:
        "Restore the shine and enhance the curb appeal of your building exterior...",
      coreFeatures: [
        "Eco-friendly cleaning agents",
        "Removal of pollution stains and mold",
        "High-quality equipment",
        "Protection of building structure",
        "Improved curb appeal",
      ],
      image: services4,
    },
    {
      id: 4,
      title: "Project Cleaning",
      slug: "project-cleaning",
      description:
        "Comprehensive post-construction cleaning services that prepare your site for immediate occupancy...",
      coreFeatures: [
        "Debris and dust removal",
        "Surface and window cleaning",
        "Floor polishing and cleaning",
        "Safe disposal of construction waste",
        "Ready-for-occupancy preparation",
      ],
      image: services5,
    },
  ];

  return (
    <>
      <section className="about-banner position-relative overflow-hidden">
        <div className="container position-relative z-index-1">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <h1 className="display-5 fw-bold mb-4">
                Redefining Facility Management
              </h1>
              <p>
                At RR Facility Services, we combine cutting-edge technology with
                human expertise to deliver unparalleled facility solutions
                across industries.
              </p>
              <AnimatedButton text="Get in Touch" />
            </div>
          </div>
        </div>
      </section>

      <section className="my-5">
        <div className="container">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`row align-items-center bg-light border-1 mb-5 p-0 rounded-5 ${
                index % 2 !== 0 ? "flex-row-reverse" : ""
              } ${isScrolled ? "stacked-effect" : ""}`}
              style={{
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                transform: isScrolled ? `translateY(-${index * 20}px)` : "none",
                zIndex: isScrolled ? 100 - index : "auto",
              }}
            >
              {/* Image Column */}
              <div className="col-md-6 mb-3 mb-md-0">
                <img
                  src={service.image}
                  alt={service.title}
                  className="img-fluid rounded"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />
              </div>

              {/* Text Column */}
              <div className="col-md-6">
                <h3 className="fw-bold">{service.title}</h3>
                <p>{service.description}</p>
                {service.coreFeatures && service.coreFeatures.length > 0 && (
                  <ul>
                    {service.coreFeatures.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                )}
                {/* Use Link to service details page */}
                <Link to={`/services/${service.slug}`}>
                  <AnimatedButton text="Know More" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Services;
